<template>
  <div>
    <div class="vx-row">
        <div class="vx-col w-full">
            <vs-divider color="dark">{{title}}</vs-divider>
            <template v-if="userData">
                <!-- DATOS GENERALES DEL USUARIO -->
                <vs-list>
                    <vs-list-item v-if="userData.id" :title="userRoleIdStr">
                      <update-attribute object-db="projects" :field-option="getObjectPidOption(title)" :field-data="userData.id" @updated="dataUpdated"/>                    
                    </vs-list-item>
                    <vs-list-item title="UID">{{userData.user_id}}</vs-list-item>
                    <vs-list-item title="CORREO">
                      <update-attribute object-db="users" field-option="email" :field-data="userData.email" @updated="dataUpdated"/>
                    </vs-list-item>
                    <vs-list-item title="ACTIVE STATUS">{{userData.active_status}}</vs-list-item>
                    <vs-list-item title="TIPO DE PERSONA">{{userData.person_type}}</vs-list-item>
                    <vs-list-item title="F. CREACIÓN">{{regularDateFormat(userData.created_at)}}</vs-list-item>
                    <vs-list-item title="ÚLTIMO ACCESO">{{ userData.last_login? regularDateFormat(userData.last_login):"--"}}</vs-list-item>
                </vs-list>
                <!-- DATOS PARA EL TIPO DE PERSONA DEL USUARIO -->
                <person-type-data :userData="userData" @updated="dataUpdated"/>
                <!-- DATOS DE LOS ROLES DEL USUARIO -->
                <div v-if="showRoles && userData.roles_data">
                    <div class="flex items-center justify-between">
                      <vs-divider color="dark">ROLES</vs-divider>
                      <!-- <vs-button radius size="small"  type="filled" :disabled="userHasAllRoles" icon="add" @click="activePrompt=true" color="success" class="ml-2"></vs-button>                     -->
                    </div>
                    <div v-for="(role, i) in userData.roles_data" :key="i">
                        <label class="bold text-success mt-3">{{role.role_name}}</label>
                        <vs-list>
                            <vs-list-item title="ID">
                              {{ role.role_id }}
                              <!-- <update-attribute :object-db="getObject(role.role_name)" field-option="user_id" :field-data="role.role_id" />                             -->
                            </vs-list-item>
                            <vs-list-item title="ÚLTIMO MOVIMIENTO"> {{ role.last_movement? regularDateFormat(role.last_movement):"Sin movimientos" }}</vs-list-item>
                            <template v-if="role.role_name == 'SOLICITANTE'">
                              <vs-list-item title="PIDS"> {{ role.pids? role.pids:"Sin proyectos" }}</vs-list-item>
                            </template>
                        </vs-list>
                    </div>
                </div>
            </template>
        </div>
    </div>

    <vs-prompt
      title="Agregar rol"
      @cancel="roleToAdd=null"
      @accept="addUserRole"
      @close="roleToAdd=null"
      accept-text="Confirmar"
      cancel-text="Cancelar"
      :is-valid="validRoleToAdd"
      :active.sync="activePrompt">
       <div class="con-exemple-prompt">
         <vs-select
            class="w-full"
            label="Selecciona el rol"
            v-model="roleToAdd"
            >
            <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="item,index in userRoleOptions" />
          </vs-select>
       </div>
     </vs-prompt>
  </div>
</template>

<script lang="js">
import dateHelper from '@mixins/dateHelper';
import PersonTypeData from './PersonTypeData';
import UpdateAttribute from '@components/forms/UpdateAttribute.vue';

export default  {
  name: 'user-profile-data',
  props: {
    title: {
      type: String,
      required: true
    },
    userData: {
      required: true
    },
    showRoles: {
      type: Boolean,
      default: false
    },
  },
  components: {PersonTypeData, UpdateAttribute},
  mixins: [dateHelper],
  data() {
    return {
      userRoleOptions:[
        {text:'SOLICITANTE',value:'client'},
        {text:'INVERSIONISTA',value:'investor'},
        {text:'PROVEEDOR',value:'supplier'},
      ],
      activePrompt:false,
      roleToAdd:null
    }
  },
  computed: {
    userRoleIdStr(){
      let roleIdStr = null;
      if (this.title == "CLIENTE") {
        roleIdStr = "CID"
      } else {
        roleIdStr = "SID"
      }
      return roleIdStr;
    },
    userHasAllRoles(){
      return this.userData.roles_data.length >= 3;
    },
    validRoleToAdd() {
      return this.roleToAdd != null;
    },
  },
  async mounted() {
    this.setRoleOptions();
  },
  methods: {
    setRoleOptions(){
      this.userData.roles_data.forEach(opt => {
          console.log(opt.role_name);
          this.userRoleOptions = this.userRoleOptions.filter(function(x) { return x.text != opt.role_name; });
      })
    },
		async addUserRole() {
      this.errorMssg = null;
      this.showLoading(true, "Guardando información...");
      try {
        let payload = {
          role: this.roleToAdd,
          user_id: this.userData.user_id
        };
        await axios.post("/api/clients-control/users-profile-integration/add-role",
          payload
        );
        this.showLoading(false);
        this.$emit("updated");
      } catch (error) {
        if(error.response){
          this.errorNotifDialog("Aviso", error.response.data.message);
        }
        else {
          this.errorNotifDialog("Error", "Ha ocurrido un error");
        }
        this.showLoading(false);
      }
    },
    // getObject(option){
    //   let object = null;
    //   switch (option) {
    //     case "SOLICITANTE":
    //       object = "clients";
    //       break;
    //     case "INVERSIONISTA":
    //       object = "investors";
    //       break;
    //     case "PROVEEDOR":
    //       object = "suppliers";
    //       break;
    //     default:
    //       break;
    //   }
    //   return object;
    // },
    getObjectPidOption(option){
      let object = null;
      switch (option) {
        case "CLIENTE":
          object = "client_id";
          break;
        case "PROVEEDOR":
          object = "supplier_id";
          break;
        default:
          break;
      }
      return object;
    },
    async dataUpdated() {
      await this.$emit("updated");
    },
  }
}
</script>